"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarPrice = void 0;
var react_1 = __importDefault(require("react"));
var CarPrice_module_scss_1 = __importDefault(require("./CarPrice.module.scss"));
var formatPrice_1 = require("../../helpers/formatPrice");
var getPayment_1 = require("../../helpers/car/getPayment");
var CarPrice = function (_a) {
    var price = _a.price, extra = _a.extra;
    var oldPrice = Math.round(price * 1.25);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: CarPrice_module_scss_1.default.car_price__extra },
            (0, formatPrice_1.formatPrice)(price),
            " \u20BD"),
        react_1.default.createElement("span", { className: CarPrice_module_scss_1.default.car_price__info, "data-tooltip": "\u0426\u0435\u043D\u0430 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0430 \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u0432 \u043A\u0440\u0435\u0434\u0438\u0442", "aria-label": "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u0446\u0435\u043D\u0430\u0445", role: "note" },
            react_1.default.createElement("span", { className: CarPrice_module_scss_1.default.car_price__infoIcon, "aria-hidden": "true" })),
        react_1.default.createElement("span", { className: CarPrice_module_scss_1.default.car_price__full },
            (0, formatPrice_1.formatPrice)(oldPrice),
            " \u20BD"),
        react_1.default.createElement("br", null),
        react_1.default.createElement("span", { className: CarPrice_module_scss_1.default.car_price__month },
            (0, formatPrice_1.formatPrice)((0, getPayment_1.getPayment)(price, 0, 96, 4.9)),
            "\u20BD/\u043C\u0435\u0441. \u0431\u0435\u0437 \u0432\u0437\u043D\u043E\u0441\u0430")));
};
exports.CarPrice = CarPrice;
